import { format } from 'date-fns'
import { KpiStrip } from '@/components/KpiStrip'
import { EditorialCalendar } from '@/components/Calendar'
import { ApprovalQueue } from '@/components/ApprovalQueue'
import { WriterInvoicing } from '@/components/WriterInvoicing'
import { SeoPulse } from '@/components/SeoPulse'
import { AgentActivity } from '@/components/AgentActivity'

export function Dashboard() {
  const now = new Date()
  return (
    <div className="p-3 md:p-5 max-w-[1400px] mx-auto flex flex-col gap-3.5">
      <header className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2">
        <div>
          <h1 className="text-xl font-medium">Editorial dashboard</h1>
          <p className="text-xs text-ink-secondary">
            {format(now, 'EEEE, MMMM d')} · 14 pieces in flight
          </p>
        </div>
        <div className="flex gap-2 items-center self-end sm:self-auto">
          <button className="hidden md:inline-block text-xs text-ink-tertiary px-2 py-1 border border-border rounded-md">⌘K</button>
          <div className="w-7 h-7 rounded-full bg-status-draft-bg text-brand-800 text-xs font-medium flex items-center justify-center">VS</div>
        </div>
      </header>

      <KpiStrip />

      <div className="grid grid-cols-1 lg:grid-cols-[1.5fr_1fr] gap-3.5 min-w-0">
        <EditorialCalendar />
        <ApprovalQueue />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 min-w-0">
        <WriterInvoicing />
        <SeoPulse />
        <AgentActivity />
      </div>
    </div>
  )
}
